import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0acffeaa&"
import script from "./task.js?vue&type=script&lang=js&"
export * from "./task.js?vue&type=script&lang=js&"
import style0 from "./task.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports